import { useCallback } from 'react';
import PropTypes from 'prop-types';

import { Button } from 'basic-components';
import { CommonService } from 'dashboard-services/services';
import { DashboardLinkFactory } from 'ng-common-features/urlBuilder';

const ModalTitle = ({ fileExtension = "" }) => {
 const createNewFile = useCallback(() => CommonService.openInNewTab(DashboardLinkFactory.dataLake.list({ query: "", tab: "Files" })), [])
  return (
    <div className="ng-common-picker__modal__title">
      <p className="ng-common-picker__modal__title__left">Select or </p>
      <Button
          onClick={createNewFile}
          size="large"
          variant="text"
      >
        Upload
      </Button>
      <p className="ng-common-picker__modal__title__right">{`${fileExtension ? fileExtension.toUpperCase() : "Data lake"} file`}</p>
    </div>
  )
}

ModalTitle.propTypes = {
  fileExtension: PropTypes.string,
}

export default ModalTitle;
